import React from 'react';

import './ourteam.css'


const OurTeam = () => (    
    
    <div className="aaa">        
        <div className="viaferrata-header">
            <div className="viaferrata-header__logo">    
                <img  className="viaferrata-header__logo-img"  alt="PK Greben" src="img/logo-greben.png"/> 
            </div>
        </div>     
        <section className="our-team-section">                       
               
            <h1 className="heading-secondary u-margin-bottom-small heading-aboutus-page">Naš Tim</h1>
            

<ul className="our-team-card-list">
                 
            <li className="our-team-card">
               <h4 className="our-team-card-titula">Predsednik</h4>
               <div className="our-team-card-content">
               <img src="/img/user-12.jpg
               " alt="Nasi Vrhovi pdf" className="our-ream-img"  />
                <div className="our-team-card-info">
                    <p>Branko Marković</p>
                    <p><i className="najave-font icofont-viber"></i>064/1983719</p>
                </div>
                </div>
            </li>
            <li className="our-team-card">
               <h4 className="our-team-card-titula">Podpredsednik</h4>
               <div className="our-team-card-content">
               <img src="/img/user-12.jpg
               " alt="Nasi Vrhovi pdf"  className="our-ream-img" />
                <div className="our-team-card-info">
                    <p>Dejan Jaćimović</p>
                    <p><i className="najave-font icofont-viber"></i>064/6151403</p>
                </div>
                </div>
            </li>
            </ul>
            <ul className="our-team-card-list">
            <li className="our-team-card">
               <h4 className="our-team-card-titula">Načelnik</h4>
               <div className="our-team-card-content">
               <img src="/img/user-12.jpg
               " alt="Nasi Vrhovi pdf"  className="our-ream-img" />
                <div className="our-team-card-info">
                    <p>Miloš Jeremić</p>
                    <p><i className="najave-font icofont-viber"></i>064/1776253</p>
                </div>
                </div>
            </li>
            <li className="our-team-card">
               <h4 className="our-team-card-titula">Sekretar</h4>
               <div className="our-team-card-content">
               <img src="/img/user-12.jpg
               " alt="Nasi Vrhovi pdf"  className="our-ream-img" />
                <div className="our-team-card-info">
                    <p>Romana Žmurić</p>
                    <p><i className="najave-font icofont-viber"></i>063/8234802</p>
                </div>
                </div>
            </li>
            <li className="our-team-card">
               <h4 className="our-team-card-titula">Via Ferrata Team</h4>
               <div className="our-team-card-content">
               <img src="/img/user-12.jpg
               " alt="Nasi Vrhovi pdf"   className="our-ream-img"/>
                <div className="our-team-card-info">
                    <p>Miroslav Čolić</p>
                    <p> <i className="najave-font icofont-viber"></i>064/4211441</p>
                </div>
                </div>
            </li>
            </ul>
            <ul className="our-team-card-list">
            <li className="our-team-card">
               <h4 className="our-team-card-titula">Član UO</h4>
               <div className="our-team-card-content">
               <img src="/img/user-12.jpg
               " alt="Nasi Vrhovi pdf"  className="our-ream-img"/>
                <div className="our-team-card-info">
                    <p>Suzana Filipović</p>
                    <p><i className="najave-font icofont-viber"></i>065/8236952</p>
                </div>
                </div>
            </li>
            <li className="our-team-card">
               <h4 className="our-team-card-titula">Član UO</h4>
               <div className="our-team-card-content">
               <img src="/img/user-12.jpg
               " alt="Nasi Vrhovi pdf"  className="our-ream-img" />
                <div className="our-team-card-info">
                    <p>Jelena Rakić</p>
                    <p><i className="najave-font icofont-viber"></i>066/062536</p>
                </div>
                </div>
            </li>
            <li className="our-team-card">
               <h4 className="our-team-card-titula">Član UO</h4>
               <div className="our-team-card-content">
               <img src="/img/user-12.jpg
               " alt="Nasi Vrhovi pdf"  className="our-ream-img" />
                <div className="our-team-card-info">
                    <p>Angelina Jeremić</p>
                    <p><i className="najave-font icofont-viber"></i>060/5057626</p>
                </div>
                </div>
            </li>          
           
            </ul>  

             <ul className="ourteam-greben">   
                <li>adresa:</li> 
                <li>PK GREBEN</li> 
                <li>Kralja Petra I 175</li>  
                <li>11400 Mladenovac</li>
                <li> E-mail greben.pk@gmail.com</li>               

            </ul>
              
             
              
           
        
           
        </section>   
      
       
    <div className="our-team-footer">
            <p className="our-team-footer-copywrite"> © 2020 by PK Greben</p>  
    </div>
    </div>

);


export default OurTeam;